import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SeeAllModule from "./admin/SeeAllModule";
import { isFeatureEnabled } from "../global/GlobalTools";

import ProfileImageViewer from "../global/modals/ProfileImageViewer";

const customStyles = {
  styleImg: {
    display: "block",
    width: "100%",
    height: "100%",
    maxWidth: "150px",
    maxHeight: "150px",
    aspectRatio: "1/1",
    objectFit: "cover",
  },
  lazy: {
    height: "25px",
  },
  lazyImgRelative: {
    height: "107px",
    borderRadius: "75px",
    width: "114px",
  },
  containerInfo: {
    height: "116px",
  },
  profileImageContainer: {
    position: "relative",
    display: "inline-block",
    width: "100%",
    maxWidth: "100px",
    maxHeight: "100px",
    aspectRatio: "1/1",
    objectFit: "cover",
  },
  searchIcon: {
    position: "absolute",
    right: "8px",
    bottom: "8px",
    background: "#f5f5f5",
    borderRadius: "50%",
    padding: "2px 6px",
    fontSize: "1.2em",
    color: "#999999",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    zIndex: 2,
    height: "25px",
    width: "25px",
    float: "inline-end",
  },
};

const lazyLoadingStudentInRelative = () => {
  return (
    <div>
      <Row className="table-lazyLoading">
        <Col md={3}>
          <div style={customStyles.lazyImgRelative}></div>
        </Col>
        <Col md={9}>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading">
        <Col md={8}>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-3">
        <Col md={2} className="offset-md-10">
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
    </div>
  );
};

const StudentInfo = (props) => {
  const [t] = useTranslation([
    "dashboardStudent",
    "organizations",
    "crm",
    "class",
    "dashboard",
    "student",
  ]);
  const [loadingStudent, setLoadingStudent] = useState(true);
  const [data, setData] = useState({});
  const [showProfileImageViewer, setShowProfileImageViewer] = useState(false);

  /**
   * Initial Loading
   */
  useEffect(() => {
    if (props.studentSelected.id) {
      setData(props.studentSelected);
      setLoadingStudent(false);
    }
  }, [props.studentSelected]);

  return (
    <>
      <Row>
        <Col md={12} className="mt-3">
          {loadingStudent ? (
            lazyLoadingStudentInRelative()
          ) : (
            <>
              <Row>
                <Col md={3} style={{ alignContent: "center" }}>
                  <div style={customStyles.profileImageContainer}>
                    <img
                      id="profileImage"
                      src={
                        data.image_url
                          ? data.image_url
                          : "/img/student_placeholder.svg"
                      }
                      className="rounded-circle img-fluid"
                      style={customStyles.styleImg}
                    />
                    {data.image_url && isFeatureEnabled("Importar_Imagenes_Estudiantes") && (
                      <i
                        id="zoomIcon"
                        className="bi bi-search"
                        style={customStyles.searchIcon}
                        role="button"
                        onClick={() => setShowProfileImageViewer(true)}
                      />
                    )}
                  </div>
                </Col>
                <Col md={9} style={{minHeight: "100px"}}>
                  <Row>
                    <b className="fs-3">{data.name}</b>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12} style={customStyles.containerInfo}>
                  <Row>
                    <p>
                      <b>{t("organizations:modalCreate.email")}: </b>
                      {data.email}
                    </p>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <p>
                        <b>{t("class:table.grade")}: </b>
                      </p>
                    </Col>
                    <Col md={2}>
                      <b>{t("class:table.group")}: </b>
                    </Col>
                    <Col md={2}>
                      <b>{t("class:modalImport.level")}: </b>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={2}>
                      <p>{data.grade}</p>
                    </Col>
                    <Col md={2}>
                      <p>{data.group}</p>
                    </Col>
                    <Col md={8}>
                      <p>{data.school_level}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <SeeAllModule
                    isCMv1={true}
                    customText={t("dashboard:labels.viewProfile")}
                    path={`/estudiante/${props.studentSelected.id}`}
                  ></SeeAllModule>
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
      {showProfileImageViewer && (
        <ProfileImageViewer
          show={showProfileImageViewer}
          title={t("student:ModalImportProfilePhotos.profilePicture")}
          txtBtnAccept={t("global:buttons.close")}
          url={data.image_url}
          fnAcceptButton={() => setShowProfileImageViewer(false)}
        />
      )}
    </>
  );
};

export default StudentInfo;

StudentInfo.propTypes = {
  studentSelected: PropTypes.object,
};
